var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c(
            "h3",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tipoReporte == "P",
                  expression: "tipoReporte == 'P'"
                }
              ]
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    "Reporte de efectividad por " +
                      (_vm.tipoPersona == "S" ? "supervisores" : "vendedores")
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "h3",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tipoReporte == "D",
                  expression: "tipoReporte == 'D'"
                }
              ]
            },
            [
              _vm._v(
                "\n        Reporte de efectividad global detallada\n      "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.mostrarHistoricos }
              },
              [
                _c("i", { staticClass: "fa fa-history" }),
                _c("span", [_vm._v("Historial")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.exportarDocumento("E")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Excel")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-danger",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.exportarDocumento("P")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-pdf-o" }),
                _c("span", [_vm._v("PDF")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-8" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "H" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "H")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Hoy")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "A" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ayer")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "P" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "P") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "P")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Personalizado")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaDesde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaDesde", $$v)
                            },
                            expression: "form.fechaDesde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Desde:")])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaHasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaHasta", $$v)
                            },
                            expression: "form.fechaHasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Hasta:")])
                      ],
                      1
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2 select2-field--stretch",
                  class: { "select2--disabled": !_vm.administraTodasBodegas }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.optionsBodegas,
                          id: "bodegas"
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodegas" } }, [
                        _vm._v("Sucursal:")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tipoPersona == "S" || _vm.tipoReporte == "D",
                    expression: "tipoPersona == 'S' || tipoReporte == 'D'"
                  }
                ],
                class:
                  "col-xs-12 col-md-" + (_vm.tipoReporte == "D" ? "6" : "8")
              },
              [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "nombre",
                          placeholder: "Seleccione...",
                          options: _vm.optionsUsuarios,
                          id: "usuarios",
                          multiple: ""
                        },
                        on: {
                          search: _vm.onSearchUsuarios,
                          input: _vm.inputUsuarios
                        },
                        model: {
                          value: _vm.selectedUsuarios,
                          callback: function($$v) {
                            _vm.selectedUsuarios = $$v
                          },
                          expression: "selectedUsuarios"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "usuarios" } }, [
                        _vm._v("Supervisores:")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tipoPersona == "V" || _vm.tipoReporte == "D",
                    expression: "tipoPersona == 'V' || tipoReporte == 'D'"
                  }
                ],
                class:
                  "col-xs-12 col-md-" + (_vm.tipoReporte == "D" ? "6" : "8")
              },
              [
                _c("div", { staticClass: "form-field select2" }, [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.optionsVendedores,
                          id: "vendedores",
                          multiple: ""
                        },
                        on: {
                          search: _vm.onSearchVendedores,
                          input: _vm.inputVendedores
                        },
                        model: {
                          value: _vm.selectedVendedores,
                          callback: function($$v) {
                            _vm.selectedVendedores = $$v
                          },
                          expression: "selectedVendedores"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "vendedores" } }, [
                        _vm._v("Vendedores:")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-3" }, [
              _c(
                "div",
                { staticClass: "form-field select2 select2-field--stretch" },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.optionsRangoVentas,
                          id: "rangoVentas"
                        },
                        on: { input: _vm.inputRangoVentas },
                        model: {
                          value: _vm.selectedRangoVentas,
                          callback: function($$v) {
                            _vm.selectedRangoVentas = $$v
                          },
                          expression: "selectedRangoVentas"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "rangoVentas" } }, [
                        _vm._v("Ventas:")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.selectedRangoVentas != null,
                    expression: "selectedRangoVentas != null"
                  }
                ],
                staticClass: "col-md-1"
              },
              [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        placeholder: "Digite un valor...",
                        id: "rangoVentas",
                        name: "rangoVentas"
                      },
                      model: {
                        value: _vm.form.rangoVentas,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "rangoVentas", $$v)
                        },
                        expression: "form.rangoVentas"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.registros.length > 0
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.nombreBodega != null && _vm.nombreBodega != "",
                          expression:
                            "nombreBodega != null && nombreBodega != ''"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c("h6", [
                        _vm._v(_vm._s("SUCURSAL: " + _vm.nombreBodega))
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", { staticClass: "table--bordered" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.tipoReporte != "D"
                                        ? "#"
                                        : "Supervisor"
                                    ) +
                                    "\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.tipoPersona == "S" &&
                                        _vm.tipoReporte != "D"
                                        ? "Supervisor"
                                        : "Vendedor"
                                    ) +
                                    "\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Sucursal\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.diasSemana, function(diaSemana, index) {
                              return _c(
                                "th",
                                {
                                  key:
                                    index.toString() +
                                    _vm
                                      .moment(new Date())
                                      .format("YYYYMMDDHHmmss") +
                                    "dia",
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(diaSemana.nombre_dia))
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Ventas\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Total\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Dev.\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Cobro\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    No Cobro\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Valor\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    % Cobrada\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    % Dev.\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    % No Cobro\n                  "
                                )
                              ]
                            )
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.registros, function(registro, index2) {
                            return _c(
                              "tr",
                              {
                                key:
                                  index2.toString() +
                                  _vm
                                    .moment(new Date())
                                    .format("YYYYMMDDHHmmss") +
                                  "reg",
                                style: registro.es_total
                                  ? "background-color:#F3F2F2;"
                                  : ""
                              },
                              [
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.tipoReporte != "D"
                                            ? index2 + 1
                                            : registro.supervisor_nombre
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(registro.persona_nombre) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(registro.bodega_nombre) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(registro.detalles, function(
                                  detalle,
                                  index3
                                ) {
                                  return _c(
                                    "td",
                                    {
                                      key:
                                        index3.toString() +
                                        _vm
                                          .moment(new Date())
                                          .format("YYYYMMDDHHmmss") +
                                        "det",
                                      staticStyle: { "font-size": "10px" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(detalle.ventas))
                                      ])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [_vm._v(_vm._s(registro.total_ventas))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(registro.total_valores) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(registro.total_devoluciones) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [_vm._v(_vm._s(registro.total_cobros))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(registro.total_no_cobros) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          registro.total_valores_cobrados
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(registro.porcentaje_cobrado) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(registro.porcentaje_devolucion) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(registro.porcentaje_no_cobro) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "tr",
                            [
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  },
                                  attrs: { colspan: "3" }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        "T. VENTAS " +
                                          (_vm.tipoPersona == "S"
                                            ? "SUPERVISORES:"
                                            : "VENDEDORES:")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.diasSemana, function(
                                diaSemana,
                                index4
                              ) {
                                return _c(
                                  "td",
                                  {
                                    key:
                                      index4.toString() +
                                      _vm
                                        .moment(new Date())
                                        .format("YYYYMMDDHHmmss") +
                                      "dia_total",
                                    staticStyle: {
                                      "font-size": "10px",
                                      "background-color": "#f3f2f2"
                                    }
                                  },
                                  [_c("b", [_vm._v(_vm._s(diaSemana.ventas))])]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [_c("b", [_vm._v(_vm._s(_vm.totalVentas))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [_c("b", [_vm._v(_vm._s(_vm.totalValores))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.totalDevoluciones))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [_c("b", [_vm._v(_vm._s(_vm.totalCobros))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [_c("b", [_vm._v(_vm._s(_vm.totalNoCobros))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.totalValoresCobrados))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.porcentajeCobrado))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.porcentajeDevolucion))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.porcentajeNoCobrado))
                                  ])
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        2
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "historicos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [
          _c("reportes-historicos-excel", {
            attrs: { tipoReporte: _vm.tipo_reporte_historico }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-046896c7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-046896c7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteEfectividadPersona.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-046896c7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteEfectividadPersona.vue
// module chunks = 0